import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getText, TEXT_KEY } from '../../../utils/localization';
import { TooltipTypes } from '../../../utils/tooltipConstants';
import { MISSIONS_TYPES } from '../constants';
export var MissionsIconTooltipDetail = function MissionsIconTooltipDetail(title) {
  var _getMissionIconPositi = getMissionIconPositionAndStyle(),
    tooltipStyle = _getMissionIconPositi.tooltipStyle;
  var detail = {
    popUpType: TooltipTypes.BOTTOM,
    title: "".concat(title, "..."),
    style: tooltipStyle
  };
  return detail;
};
var getMissionIconPositionAndStyle = function getMissionIconPositionAndStyle() {
  var targetElement = document.getElementById('MISSIONS_ICON');
  var elementPosition = targetElement === null || targetElement === void 0 ? void 0 : targetElement.getBoundingClientRect();
  var x_pos = elementPosition === null || elementPosition === void 0 ? void 0 : elementPosition.x;
  var y_pos = elementPosition === null || elementPosition === void 0 ? void 0 : elementPosition.y;
  var tooltipStyle = {
    zIndex: 1000,
    left: x_pos ? x_pos - 155 : '10%',
    top: y_pos ? y_pos - 100 : '70%'
  };
  return {
    tooltipStyle: tooltipStyle
  };
};
export var TabsTooltipDetail = function TabsTooltipDetail(assetBackground, type, targetElement) {
  var position = {
    right: type === MISSIONS_TYPES.EXPLORER ? '18vw' : '3vw',
    top: '10vw'
  };
  if (targetElement !== null && targetElement !== void 0 && targetElement.current) {
    var rect = targetElement.current.getBoundingClientRect();
    position = {
      right: "unset",
      left: "".concat(rect.x - (window.innerWidth < 1200 ? 260 : 200), "px"),
      top: "".concat(rect.y + rect.height * 1.2, "px")
    };
  }
  var detail = {
    popUpType: TooltipTypes.BOTTOM,
    assetBackground: assetBackground,
    title: type === MISSIONS_TYPES.EXPLORER ? getText(TEXT_KEY.FINISH_MISSIONS_BATTLES) : getText(TEXT_KEY.FINISH_MISSIONS_EXPLORER),
    style: _objectSpread({
      zIndex: 1000,
      width: '380px',
      height: '100px',
      padding: '0 2vw'
    }, position),
    titleStyle: {
      paddingBottom: 5,
      fontStyle: 'normal',
      fontSize: '18px'
    }
  };
  return detail;
};
export var TabsCountDownTooltipDetail = function TabsCountDownTooltipDetail(assetBackground, targetElement) {
  var position = {
    right: '3vw',
    top: '12.5vw'
  };
  if (targetElement !== null && targetElement !== void 0 && targetElement.current) {
    var rect = targetElement.current.getBoundingClientRect();
    position = {
      right: "unset",
      left: "".concat(rect.x - (window.innerWidth < 1200 ? 260 : 200), "px"),
      top: "".concat(rect.y + rect.height * 2.1, "px")
    };
  }
  var detail = {
    popUpType: TooltipTypes.BOTTOM,
    assetBackground: assetBackground,
    title: getText(TEXT_KEY.COUNTDOWN_UNTIL_BATTLE_BEGGINS),
    style: _objectSpread(_objectSpread({}, position), {}, {
      zIndex: 1000,
      width: '380px',
      height: '100px'
    }),
    titleStyle: {
      paddingBottom: 5,
      textTransform: 'uppercase',
      fontSize: '18px',
      fontStyle: 'normal'
    }
  };
  return detail;
};